import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface PresentationModeContextValue {
  isPresentation: boolean;
  setPresentation: (active: boolean) => void;
}

const PresentationModeContext = createContext<PresentationModeContextValue | null>(null);

export function PresentationModeProvider({ children }: { children: React.ReactNode }) {
  const [isPresentation, setPresentationState] = useState(false);
  const setPresentation = useCallback((active: boolean) => {
    setPresentationState(active);
  }, []);

  const value = useMemo(
    () => ({ isPresentation, setPresentation }),
    [isPresentation, setPresentation]
  );

  return (
    <PresentationModeContext.Provider value={value}>{children}</PresentationModeContext.Provider>
  );
}

export function usePresentationMode(): PresentationModeContextValue {
  const ctx = useContext(PresentationModeContext);
  if (!ctx) {
    return { isPresentation: false, setPresentation: () => {} };
  }
  return ctx;
}
